import React, { memo, useState, useEffect } from "react";
import { Routes, Route, useHistory } from "react-router-dom";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import { DataGrid } from "@mui/x-data-grid";
import {
  listarSolicitudesPorDigitar,
  obtenerSolicitudesExpress,
} from "../../services/creditoServices";

import "../../styles/main.css";
import { diccionarioGrupo } from "app/modules/shared/dictionary/extensionDocumentos";

function DigitacionContent() {
  const [solicitudes, setSolicitudes] = useState();
  const [flujoSol, setflujoSol] = useState("Revision");

  useEffect(() => {
    getSolicitudes();
  }, []);

  const getSolicitudes = () => {
    obtenerSolicitudesExpress()
      .then((response) => {
        if (response.state) {
          setSolicitudes(response.data);
        }
      })
      .catch((_errors) => {
        console.log(_errors);
      });
  };

  const renderDetailsButton = (params) => {
    return (
      <strong>
        <Button
          variant="outlined"
          color="primary"
          size="small"
          style={{ marginLeft: 16 }}
          onClick={() => {
            routeChange(params.row);
          }}
        >
          Digitar
        </Button>
      </strong>
    );
  };

  const formatearFecha = (fecha) => {
    if (!fecha) {
      return "";
    }
    const fechaModificada = fecha.split("T");
    return fechaModificada[0];
  };

  const columns = [
    {
      field: "idPreevaluacion",
      hide: true,
      headerName: "ID",
      width: 70,
      headerClassName: "header-grid-solicitud",
    },
    {
      field: "idCliente",
      hide: true,
      headerName: "IDCliente",
      width: 70,
      headerClassName: "header-grid-solicitud",
    },
    {
      field: "identificacion",
      headerName: "Identificacion",
      headerClassName: "header-grid-solicitud",
      width: 150,
      editable: false,
    },
    {
      field: "fechaSolicitud",
      headerName: "Fecha de Solicitud",
      headerClassName: "header-grid-solicitud",
      width: 150,
      editable: false,
      valueFormatter: (params) => {
        return formatearFecha(params.value);
      },
    },
    {
      field: "montoSolicitado",
      headerName: "Monto Solicitado",
      headerClassName: "header-grid-solicitud",
      width: 150,
      editable: false,
    },
    {
      field: "montoAprobado",
      headerName: "Monto Aprobado",
      headerClassName: "header-grid-solicitud",
      width: 150,
      editable: false,
    },
    {
      field: "idLocal",
      headerName: "Local",
      headerClassName: "header-grid-solicitud",
      width: 140,
      editable: false,
    },
    {
      field: "idGrupo",
      headerName: "Grupo",
      headerClassName: "header-grid-solicitud",
      width: 250,
      editable: false,
      valueFormatter: (params) => {
        return diccionarioGrupo(params.value);
      },
    },
    {
      field: "digitacion",
      headerName: "Digitacion",
      headerClassName: "header-grid-solicitud",
      width: 150,
      renderCell: renderDetailsButton,
      disableClickEventBubbling: false,
    },
  ];

  const rows = solicitudes;

  const history = useHistory();
  const routeChange = (row) => {
    // console.log({row});

    const path = "/credito/digitacionSolicitud";
    history.push(path, {
      data: {
        idPreevaluacion: row.idPreevaluacion,
        idCliente: row.idCliente,
        identificacion: row.identificacion,
      },
    });
  };

  return (
    <div>
      <Box sx={{ height: 800, width: "100%" }}>
        <DataGrid
          getRowId={(row) => row.idPreevaluacion}
          rows={rows}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[5]}
          disableSelectionOnClick
        />
      </Box>
    </div>
  );
}

export default memo(DigitacionContent);
